import {TimeTexts} from "../../../dashboard/DashboardContainer";

export class StatisticsUtils {

    public static getPercentage = (total: number, value: number): number => {
        return 100 * value / total;
    }

    public static dataComparator =
        (type: string, a: any, b: any, key: string, customOrderKey: string): number => {
            if (a[key] === undefined || (type === "custom" && a[customOrderKey] === undefined)) {
                throw new Error("key or customOrderKey not available for given element");
            }
            switch (type) {
                case "asc":
                    return a[key] - b[key];
                case "desc":
                    return b[key] - a[key];
                case "custom":
                    return a[customOrderKey] - b[customOrderKey];
                default:
                    return a[key] - b[key];
            }
        }

    /**
     * Given a period in seconds return a string that describe it
     * @param seconds the period to translate in words
     * @param timeTexts translation for time unit words
     */
    public static periodInWords(seconds: number, timeTexts: TimeTexts, maxNumberTimeUnits: number) {
        let period = seconds;

        const years = Math.floor(period / (60 * 60 * 24 * 365));
        if (years > 0) {
            period -= (years * 31556926); // 31556926 = 1 year in seconds
        }
        const months = Math.floor(period / (60 * 60 * 24 * 30));
        if (months > 0) {
            period -= (months * 2629743); // 2629743) = 1 month in seconds
        }
        const days = Math.floor(period / (60 * 60 * 24));
        if (days > 0) {
            period -= (days * 86400); // 86400 = 1 day in seconds
        }
        const hours = Math.floor(period / (60 * 60));
        if (hours > 0) {
            period -= (hours * 3600); // 3600 = 1 hour in seconds
        }
        let minutes = Math.floor(period / 60);
        if (minutes === 0 && period > 0) {
            minutes = 1;
        }

        return StatisticsUtils.formatPeriodString(years, months, days, hours, minutes, timeTexts, 2);
    }

    /**
     * Concatenate each time units value with its meaning
     * FIXME: don't truncate but rounds the value when maxNumberTimeUnits is setted
     */
    public static formatPeriodString(
        years: number,
        months: number,
        days: number,
        hours: number,
        minutes: number,
        timeTexts: TimeTexts,
        maxNumberTimeUnits: number,
    ) {

        let periodInWords = "";
        let numberTimeUnits = 0;
        if (years > 0) {
            periodInWords += years + " " + (years === 1 ? timeTexts.year : timeTexts.years);
            numberTimeUnits++;
        }
        if (months > 0) {
            if (periodInWords !== "") {
                periodInWords += " ";
            }
            periodInWords += months + " " + (months === 1 ? timeTexts.month : timeTexts.months);
            numberTimeUnits++;
        }
        if (numberTimeUnits === maxNumberTimeUnits) {
            return periodInWords;
        }
        if (days > 0) {
            if (periodInWords !== "") {
                periodInWords += " ";
            }
            periodInWords += days + " " + (days === 1 ? timeTexts.day : timeTexts.days);
            numberTimeUnits++;
        }
        if (numberTimeUnits === maxNumberTimeUnits) {
            return periodInWords;
        }
        if (hours > 0) {
            if (periodInWords !== "") {
                periodInWords += " ";
            }
            periodInWords += hours + " " + (hours === 1 ? timeTexts.hour : timeTexts.hours);
            numberTimeUnits++;
        }
        if (numberTimeUnits === maxNumberTimeUnits) {
            return periodInWords;
        }
        if (minutes > 0) {
            if (periodInWords !== "") {
                periodInWords += " ";
            }
            periodInWords += minutes + " " + (minutes === 1 ? timeTexts.minute : timeTexts.minutes);
        }
        return periodInWords;
    }
}
